import _isEmpty from 'lodash/isEmpty';

const _processColumnItems = (columnItems, checkEmpty) =>
    columnItems.some((columnItem) => {
        if (columnItem.type === 'PARAGRAPH') {
            return checkEmpty
                ? _isEmpty(columnItem.content.textMarkupValue)
                : !Object.prototype.hasOwnProperty.call(columnItem.content, 'textMarkupValue');
        }
        return false;
    });

const _processColumns = (columns, checkEmpty) =>
    columns.some((column) => _processColumnItems(column.columnItems, checkEmpty));

/**
 *
 * @param {object} jsonData
 * @param {boolean} checkEmpty
 * @returns {boolean}
 */
const checkMissingMarkupValue = (jsonData, checkEmpty = false) =>
    jsonData.some((block) => block.type === 'CUSTOMIZED_BLOCK' && _processColumns(block.content.columns, checkEmpty));

export default checkMissingMarkupValue;
